import cx from 'classnames';
import CustomSelect from '../../../CustomSelect/CustomSelect';
import { IRangeDates } from '../../../month-range-picker-with-options/model/types/IRangeDates';
import { useFilterPanelContext } from '../../context/FilterPanelContext';
import style from '../../FilterPanel.module.scss';
import DateRangeField from '../DateRangeField/DateRangeField';
import MonthRangeField from '../MonthRangeField/MonthRangeField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import NumberInputField from '../NumberInputField/NumberInputField';
import SelectField from '../SelectField/SelectField';
import { DatePicker } from '@fsd/shared/ui/DatePicker';
import { Dayjs } from 'dayjs';
import { RangePicker } from '@fsd/shared/ui/RangePicker';
import styles from '@fsd/pages/mutual-settlements/ui/CreateReconciliationModal/CreateReconciliationModal.module.scss';
import { mutualSettlementsStore } from '@fsd/pages/mutual-settlements/model/store/MutualSettlementsStore';
import { AppRangePicker } from '@fsd/shared/ui/AppDatePicker';

const Filters = () => {
  const {
    showFilters,
    fields,
    values,
    setValues,
    autocomplete,
    setAutocomplete,
    isClear,
    maxWidth,
  } = useFilterPanelContext();

  const handleInputChange = (
    key: string,
    value: string | [string, string] | IRangeDates | Dayjs | [Dayjs, Dayjs]
  ) => {
    setValues({ ...values, [key]: value });
  };

  if (!showFilters) return null;

  return (
    <div className={cx(style.filtersRow, { [style.clear]: isClear })}>
      {fields?.map((field) => {
        if (field.type === 'dateRange') {
          return (
            <DateRangeField
              key={field.key}
              value={values?.[field.key] as [string, string]}
              onChange={(val: [string, string]) =>
                handleInputChange(field.key, val)
              }
              label={field.label}
              className={field.className}
              disabled={field.disabled}
            />
          );
        }

        if (field.type === 'rangePicker') {
          return (
            <div
              key={field.key}
              className={cx(style.filterItem, field.className)}
              style={{ maxWidth: maxWidth ?? 'none' }}
            >
              <label>{field.label}</label>
              <AppRangePicker
                value={values?.[field.key] as [Dayjs, Dayjs]}
                onChange={(val) => {
                  if (val) handleInputChange(field.key, val);
                }}
                placeholder={['Начало', 'Конец']}
                style={{ height: 40, marginTop: 1, marginLeft: 1 }}
              />
            </div>
          );
        }

        if (field.type === 'datePicker') {
          return (
            <div
              key={field.key}
              className={cx(style.filterItem, field.className)}
              style={{ maxWidth: maxWidth ?? 'none' }}
            >
              <label>{field.label}</label>
              <DatePicker
                value={values?.[field.key] as Dayjs}
                onChange={(val: Dayjs) => handleInputChange(field.key, val)}
                placeholder="Дата"
                style={{ height: 40, marginTop: 1, marginLeft: 1 }}
              />
            </div>
          );
        }

        if (field.type === 'monthRange') {
          return (
            <MonthRangeField
              label={field.label}
              dates={values?.[field.key] as IRangeDates}
              setDates={(dates: IRangeDates) =>
                handleInputChange(field.key, dates)
              }
              className={field.className}
              disabled={field.disabled}
            />
          );
        }

        if (field.type === 'input') {
          const inputValue = values?.[field.key] as string;

          return (
            <div
              key={field.key}
              className={cx(style.filterItem, field.className)}
            >
              <label>{field.label}</label>
              <input
                type="text"
                className={style.autocompleteInput}
                value={inputValue}
                placeholder="Введите..."
                onChange={(e) => handleInputChange(field.key, e.target.value)}
                disabled={field.disabled}
              />
            </div>
          );
        }

        if (field.type === 'numberInput') {
          const inputValue = values?.[field.key] as string;

          return (
            <NumberInputField
              field={field}
              inputValue={inputValue}
              values={values}
              setValues={setValues}
            />
          );
        }

        if (field.type === 'select')
          // return (
          //   <SelectField
          //     style={{ maxWidth: maxWidth ?? 'none' }}
          //     field={field}
          //   />
          // );
          return (
            <SelectField
              style={{ maxWidth: maxWidth ?? 'none' }}
              field={field}
            />
          );

        if (field.type === 'multiselect')
          return (
            <MultiSelectField
              field={field}
              style={{ maxWidth: maxWidth ?? 'none' }}
            />
          );
        return null;
      })}
    </div>
  );
};

export default Filters;
